<template>
  <div class="app-page-wrapper showFooterView">
    <div>
      <div class="showIcon">
        <img class="logo" src="@/assets/home/icon_logo.png" alt="" />
        <img class="hintUnion" src="@/assets/union_hint_icon.png" alt="" />
      </div>
      <p class="showUnionMsg">
        <span>地址：河南省漯河市黄河路461号</span> 
        <span>邮编：462000</span>
        <span>电话：0395-3131533</span>
      </p>
      <p class="showUnionMsg">
        <span>版权所有：漯河市总工会</span>
        <span>职工维权热线：12351</span>
      </p>
      <div class="showUnionMsg">
        <p style="float:left;">备案号：</p>
		 		<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41110302000041" >
          <img src="" style="float:left;"/>
          <p style="float:left;height:20px;line-height:33px;margin: 0px 0px 0px 5px; color:#fff; margin-right:5px;">
            豫公网安备 41110302000041号
          </p>
        </a>
        <a target="_blank" href="https://beian.miit.gov.cn/">
          <p style="color:#fff">豫ICP备09015058号-1</p>
        </a>
      </div>
      <p class="showUnionMsg">技术支持：上海建朗信息科技有限公司</p>
    </div>
    <div style="text-align: center;">
      <img class="qrcode-img" src="@/assets/home/qr_code.jpg" alt="">
      <p class="qrcode-text">扫描二维码关注</p>
      <p class="qrcode-text">漯河市总工会微信</p>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
  
<style lang="less" scoped>
.showFooterView {
  margin: 0 auto;
  padding-top: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .showIcon {
    display: flex;
    width: 100%;
    margin-bottom: 40px;

    .logo {
      width: 50px;
      height: 50px;
    }
    .hintUnion {
      margin-left: 10px;
      margin-top: 5px;
      height: 40px;
    }
  }

  .showUnionMsg {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 33px;
    color: #ffffff;
    opacity: 0.5;
    text-align: left;
    span{
      margin-right: 20px;
    }
  }

  .qrcode-img{
    width: 110px;
    height: 110px;
    margin-bottom: 30px;
  }
  .qrcode-text{
    font-size: 14px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.5);
    margin-bottom: 16px;
  }
}
</style>
